import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useQuery } from '@apollo/client';
import { motion } from 'framer-motion';
import { signOut } from 'next-auth/react';
import { GET_CATEGORIES } from '../../graphql/queries';
import { Category } from '../../models';
import { useCompanyBranding, useNotify } from '../../hooks';
import HomeImage from '../home/homeBanners/HomeImage';
import logo from '../../public/images/logo-meit.png';

function DropdownMenu({ closeOpen }) {
  const [companyBranding] = useCompanyBranding();
  const notify = useNotify();

  const { data: dataCategories } = useQuery<{
    categories: Category[];
  }>(GET_CATEGORIES, {
    fetchPolicy: 'cache-and-network',
    variables: {
      filter: { active: true },
    },
  });

  const handleSignOut = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    try {
      e.preventDefault();
      localStorage.removeItem('x-token-client');
      await signOut({ callbackUrl: `/sign-in` });
    } catch (error) {
      notify(error.message, 'error');
    }
  };

  return (
    <motion.button
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0 }}
      type="button"
      className="absolute top-[88px] z-50 flex flex-col w-full justify-center items-center bg-white py-5 border-b-[8px] border-color-secondary-200"
      onClick={closeOpen}
    >
      <Link href="/">
        {companyBranding?.logo?.image ? (
          <div className="flex flex-col justify-center items-center z-10">
            <HomeImage
              bannerImage={companyBranding?.logo?.image}
              fallbackSrc="image/banner"
              className="scale-150 w-[50%]"
              altText="Company Logo"
            />
          </div>
        ) : (
          <Image className="hidden md:flex" alt="logo" src={logo} height={60} />
        )}
      </Link>
      <div className="w-full flex flex-col h-full z-40">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-2 p-2">
          {dataCategories?.categories?.map((item) => (
            <div key={item?._id} className="gap-y-4">
              <Link
                href={`/category/${item?._id}`}
                as={`/category/${item?._id}`}
                key={item?._id}
              >
                <div className="h-full w-38 lg:w-full px-2 md:px-0 text-center flex justify-center items-center text-color-primary-text-300 hover:underline hover:text-color-primary-text-100">
                  {item?.name}
                </div>
              </Link>
            </div>
          ))}
          <Link href="/sections">
            <div className="bg-system-100 hover:bg-neutral-200 border-solid border border-cold-500 text-color-primary-text-300 flex items-center justify-center rounded-md py-2 px-3">
              Todas las categorías
            </div>
          </Link>
        </div>
      </div>
    </motion.button>
  );
}

export default DropdownMenu;
